// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__gIrAY","topBottomGutter":"Layout_topBottomGutter__aXTn_"};